<template>
  <v-col cols="12" class="px-2 pt-0" :data-invalid="this.rules?.length > 0" :data-message="this.rules?.join('<br />')">
    <b>Parcelas</b>
    <p v-if="!value.Prazo || !valorSolicitado || !value.DtEmissao">Selecione o número de parcelas para preencher o fluxo</p>
    <v-input v-else v-model="model" :rules="rules"  hide-details>
      <v-simple-table >
        <template v-slot:default>
          <thead>
            <tr>
              <th width="100"> Parcela </th>
              <th> Data de Vencimento  </th>
              <th>  Valor da Parcela  </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in value.Prazo" :key="index">
              <td class="w-50">Parcela {{ item }}</td>
              <td class="py-2">
                <InputDateText
                  v-model="model.DtVencimento[item]"
                  name="Data de Vencimento"
                  required
                  :min="dtMin(item)"
                  :max="dtMax(item)"
                  clearable
                  />
              </td>
              <td class="py-2">
                <input-number v-if="!isLastParcel(item)" :name="`Valor da Parcela ${item}`" v-model="model.VlrParcela[item]" format="currency" required :rules="vlrParcelaRules(model.VlrParcela[item])" />
                <p v-else>O sistema irá calcular esta parcela com base nos valores anteriores.</p>
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </v-input>
  </v-col>
</template>
<script>
export default {
  props: {
    value: null,
    tipoValor: null,
  },
  data () {
    return {
      model: {
        VlrParcela: this.getParcelas(),
        DtVencimento: this.getDtVencimento(),
      },
    };
  },
  mounted () {
    const th = this

    for (const [Numeroparcela] of Object.entries(th.model.DtVencimento)) {
      if (new Date(th.model.DtVencimento[Numeroparcela]) < new Date()) {
        th.model.DtVencimento[Numeroparcela] = undefined;
      }
    }
  },
  computed: {
    rules () {
      const erros = []

      const isVencimentosSequenciais = Object.values(this.model.DtVencimento)
        .map(data => new Date(data))
        .reduce((resultado, dataAtual, indice, datas) => {
          const dataSeguinte = datas[indice + 1];
          const dataAnterior = datas[indice - 1];

          if ((dataSeguinte && dataAtual >= dataSeguinte) || (dataAnterior && dataAtual <= dataAnterior)) {
            resultado = false
          }
          return resultado
        }, true)

      if (!isVencimentosSequenciais) {
        erros.push('Vencimentos precisam ser sequenciais. ')
      }

      return erros
    },
    valorSolicitado () {
      return this.value.TipoOperacaoCred === 3 ? this.value.VlrProdutoBem : this.value.VlrSolicitado
    },
  },
  methods: {
    dtMin (numeroParcela) {
      const isPrimeiraParcela = numeroParcela === 1
      const dataParcelaAnterior = this.model.DtVencimento[numeroParcela - 1]
      const dataAComparar = isPrimeiraParcela ? this.value.DtEmissao : dataParcelaAnterior

      return dataAComparar ? this.$api.UI.Format.Date(
        this.$api.UI.Date.AddDay(dataAComparar, 1),
        'yyyy-MM-dd'
      ) : null
    },
    dtMax (numeroParcela) {
      const dataProximaParcela = this.model.DtVencimento[numeroParcela + 1]

      if (this.isLastParcel(numeroParcela) || !dataProximaParcela) return null

      return this.$api.UI.Format.Date(
        dataProximaParcela,
        'yyyy-MM-dd'
      )
    },
    getParcelas () {
      let valoresIniciais = {}

      if (this.value?.dtoFluxoIrregular?.Parcelas) {
        const parcelas = this.value.dtoFluxoIrregular.Parcelas

        valoresIniciais = parcelas.reduce((valorInicial, parcela) => {
          valorInicial[parcela.NroParcela] = parcela.Valor
          return valorInicial
        }, {});
      } else if (Array.isArray(this.value.Parcelas)) {
        const parcelas = this.value.Parcelas

        valoresIniciais = parcelas.reduce((carry, current) => {
          carry[current.Parcela] = current.VlrPrestacaoTotal
          return carry
        }, { })
      }

      return valoresIniciais
    },
    getDtVencimento () {
      let valoresIniciais = {}

      if (this.value?.dtoFluxoIrregular?.Parcelas) {
        valoresIniciais = this.value.dtoFluxoIrregular.Parcelas.reduce((valorInicial, parcela) => {
          valorInicial[parcela.NroParcela] = parcela.DtVencimento
          return valorInicial
        }, {})
      } else if (Array.isArray(this.value.Parcelas)) {
        valoresIniciais = this.value.Parcelas.reduce((carry, current) => {
          carry[current.Parcela] = current.DtVencimento
          return carry
        }, { })
      }

      return valoresIniciais
    },
    formatDateTimeZone (date) {
      if (!date) {
        return '';
      }

      const [year, month, day] = date.match(/([0-9]{4})-([0-9]{2})-([0-9]{2})/).slice(1);
      return new Date(Date.UTC(year, month - 1, day)).toISOString();
    },
    isLastParcel (parcela) {
      return Number(parcela) === this.value.Prazo
    },
    vlrParcelaRules (vlrParcela) {
      const somaParcelas = Object.values(this.model.VlrParcela).slice(0, this.value.Prazo - 1).filter(v => v)
        .reduce((total, valor) => total + Number(valor), 0);
      return [
        this.valorSolicitado > vlrParcela || 'O valor da parcela excede o limite permitido. Ajuste o valor para continuar',
        this.valorSolicitado > somaParcelas || 'O valor da soma das parcelas excede o limite permitido. Ajuste o valor para continuar'
      ]
    },
    prepareDto (model) {
      const th = this

      const documentoFederal = th.value?.DocumentoFederal || th.value.Cliente?.DocumentoFederal
      const parcelasSolicitadas = Object.keys(model.DtVencimento)

      if (!this.value.DtEmissao) return

      const isProposta = th.$route.path === '/propostas'
      const taxa = isProposta ? th.value.PercJurosMensal : th.value.TxJuros

      const dto = {
        VlrTAC: th.value.VlrTAC,
        Taxa: taxa,
        Prazo: th.value.Prazo,
        TipoPessoa: th.$api.UI.Format.SomenteNumeros(documentoFederal).length === 11 ? th.$aux.TipoPessoaEnum.PF : th.$aux.TipoPessoaEnum.PJ,
        VlrOutrosServicos: th.value.OutrosServicos ? th.value.VlrAvaliacao + th.value.VlrVistoria : 0,
        VlrSeguro: th.value.VlrSeguro,
        IOFFinanciado: true,
        VlrInicial: th.value.VlrSolicitado || th.value.VlrProdutoBem,
        DtContratacao: th.formatDateTimeZone(th.value.DtEmissao),
        AnoBase: 360,
        VlrLiquido: th.tipoValor === 1,
        Parcelas: [],
      }
      parcelasSolicitadas.forEach((item, index) => {
        dto.Parcelas.push({
          NroParcela: item,
          DtVencimento: th.formatDateTimeZone(th.model.DtVencimento[item]?.toString()?.slice(0, 10)),
        })
        if (!th.isLastParcel(item) || parcelasSolicitadas.length === 1) {
          if (th.model.VlrParcela[item]) {
            dto.Parcelas[index].Valor = th.model.VlrParcela[item]
          }
        }
      })
      th.value.dtoFluxoIrregular = dto
    }
  },
  watch: {
    'value.DtEmissao' (val) {
      if (!val) return

      for (const [Numeroparcela] of Object.entries(this.model.DtVencimento)) {
        if (this.model.DtVencimento[Numeroparcela] < val) {
          this.model.DtVencimento[Numeroparcela] = undefined
        }
      }
    },
    'value.Prazo' (val, oldVal) {
      if (!val) {
        if (!oldVal) {
          this.model = {
            VlrParcela: {},
            DtVencimento: {},
          }
        }
      }
    },
    'value.Parcelas' (val) {
      this.model = {
        VlrParcela: this.getParcelas(),
        DtVencimento: this.getDtVencimento(),
      }
    },
    'value.TxJuros' () {
      this.prepareDto(this.model)
    },
    'value.PercJurosMensal' () {
      this.prepareDto(this.model)
    },
    model: {
      deep: true,
      handler (updatedModel) {
        const th = this
        const parcelasSolicitadas = Object.keys(updatedModel.DtVencimento)
        const ultimaParcela = th.isLastParcel(parcelasSolicitadas[parcelasSolicitadas.length - 1])
        if (ultimaParcela) {
          this.prepareDto(updatedModel)
        }
      }
    },
    tipoValor (val) {
      if (this.value.dtoFluxoIrregular) {
        this.value.dtoFluxoIrregular.VlrLiquido = val === 1
      }
    }
  },
}

</script>
<style>
</style>
